import {StyleSheet} from 'react-native';
import {colorPalette, textStyles} from '../../../../../theme';

export default StyleSheet.create({
  container: {
    alignSelf: 'stretch',
    backgroundColor: colorPalette.grey0_5,
    borderRadius: 12,
    marginHorizontal: 16,
    marginBottom: 12,
    padding: 8,
  },
  titleWrapper: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-end',
  },
  title: {
    fontFamily: textStyles.bold,
    fontSize: 14,
    color: colorPalette.grey9,
    marginRight: 8,
  },
  hintWrapper: {
    flex: 1,
    alignSelf: 'stretch',
    backgroundColor: colorPalette.whiteGrey0,
    borderRadius: 12,
    marginTop: 12,
  },
  hint: {
    fontFamily: textStyles.regular,
    fontSize: 14,
    color: colorPalette.grey8,
    marginHorizontal: 16.5,
    marginVertical: 4,
  },
});
